import { NgModule } from '@angular/core';
import { RouteReuseStrategy, RouterModule, Routes } from '@angular/router';
import { commonErrorRoutes, commonModuleRoutes } from '@ui/layout/common-app/routing.common';
import { marker } from '@colsen1991/ngx-translate-extract-marker';
import { RouteEntity } from '@core/router/route.entity';
import { AuthGuard } from '@core/auth/guards/auth.guard';
import { NavbarComponent } from '@ui/layout/navbar/navbar.component';
import { submenu } from './sub.menu';
import { CacheRouteReuseStrategy } from '@core/router/cache-reuse-strategy';


const routes: Routes = [
    ...commonModuleRoutes,
    {
        path: RouteEntity.Empty,
        component: NavbarComponent,
        outlet: 'navbar',
        data: {
            subMenuItems: submenu,
        },
    },
    {
        path: RouteEntity.Empty,
        redirectTo: RouteEntity.Events,
        pathMatch: 'full',
    },
    {
        path: RouteEntity.Events,
        title: marker('modules.events.head'),
        loadChildren: () =>
            import('./features/events/events.module').then(
                (m) => m.EventsModule,
            ),
        canLoad: [AuthGuard],
    },
    {
        path: RouteEntity.Inventory,
        title: marker('modules.inventory.navbar'),
        loadChildren: () =>
            import('./features/inventory/inventory.module').then(
                (m) => m.InventoryModule,
            ),
        canLoad: [AuthGuard],
    },
    {
        path: RouteEntity.PrintedTickets,
        title: marker('modules.printed-tickets.head'),
        loadChildren: () =>
            import('./features/printed-tickets/printed-tickets.module').then(
                (m) => m.PrintedTicketsModule,
            ),
        canLoad: [AuthGuard],
    },
    ...commonErrorRoutes
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [
        {
            provide: RouteReuseStrategy,
            useClass: CacheRouteReuseStrategy,
        },
    ],
})
export class AppRoutingModule {
}
